import React, { useState } from "react";
import {
  Box,
  Paper,
  TextField,
  Button,
  Typography,
  Container,
  Alert,
  Link,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import InputAdornment from "@mui/material/InputAdornment";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { Link as RouterLink } from "react-router-dom";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");

    if (!email) {
      setError("Please enter your email.");
      return;
    }

     //api call req.
    setSubmitted(true);
  };

  return (
    <Container
      component="main"
      maxWidth="xs"
      sx={{
        width: "100%",
        px: { xs: 1, sm: 4 },
      }}
    >
      <Box sx={{ mt: 6 }}>
        <img
          src="/assets/images/osa-logo.svg"
          alt="Logo"
          style={{
            maxWidth: "204px",
            height: "auto",
            display: "block",
            margin: "0 auto",
          }}
        />
      </Box>

      <Box
        sx={{
          marginTop: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          mx: { xs: 4, sm: 0 },
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: { xs: 3, sm: 4 },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
            borderRadius: 2,
          }}
        >
          <Typography
            component="h1"
            variant="h6"
            gutterBottom
            sx={{ color: "var(--text-primary)" }}
          >
            Forgot Password
          </Typography>

          <Typography
            variant="body2"
            align="center"
            sx={{ mt:2, mb: 2 }}
          >
            Enter your email and we'll send you a link to reset your password.
          </Typography>

          {submitted ? (
            <Alert severity="success" sx={{ width: "100%", mt: 2 }}>
              If an account with that email exists, a reset link has been sent.
            </Alert>
          ) : (
            <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
              <TextField
                className="input-field"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <EmailIcon color="action" />
                    </InputAdornment>
                  ),
                }}
              />
              {error && (
                <Typography
                  variant="body2"
                  sx={{ color: "red", mt: 1, ml: 1 }}
                >
                  {error}
                </Typography>
              )}

              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{
                  mt: 3,
                  mb: 2,
                  backgroundColor: "var(--primary)",
                  textTransform: "none",
                  fontWeight: "bold",
                  "&:hover": {
                    backgroundColor: "black",
                  },
                }}
              >
                Submit
              </Button>
            </Box>
          )}

          <Link
            component={RouterLink}
            to="/login"
            variant="body2"
            underline="none"
            sx={{
              display: "flex",
              alignItems: "center",
              mt: 1,
              color: "#333",
              fontSize: "14px",
              "& svg": { fontSize: "16px", mr: 0.5 },
            }}
          >
            <ArrowBackIosNewIcon />
            Back to Login
          </Link>
        </Paper>
      </Box>
    </Container>
  );
};

export default ForgotPassword;
